import React, { useState, useEffect } from 'react';
import { FiX, FiChevronUp, FiChevronDown, FiTrash2 } from 'react-icons/fi';
import { updateSection, createSection, fetchGroups, deleteSection } from '../../../features/sections/sectionsAPI'; // Import API functions


const AddSection = ({ token, onClose, sectionInfo, onSectionUpdate }) => {
    const [sectionData, setSectionData] = useState({
        days: '',
        startHour: 1,
        endHour: 1,
        color: '',
        notes: '',
        group: '',
    });
    const [newGroup, setNewGroup] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [groups, setGroups] = useState([]);
    
    const [selectedColor, setSelectedColor] = useState(null);
    // Colors functionality
    const colors = ['red', 'blue', 'green', 'yellow', 'orange', 'purple', 'pink'];
      
    const handleColorClick = (color) => {
        setSelectedColor(color === selectedColor ? null : color);
        setSectionData((prevData) => ({ ...prevData, color: color }));
    };

    useEffect(() => {
        // Fetch groups when component mounts
        const fetchGroupsData = async () => {
            try {
                const data = await fetchGroups(token);
                setGroups(data);
            } catch (error) {
                console.error('Error fetching groups:', error);
            }
        };
        fetchGroupsData();
    }, [token]);

    useEffect(() => {
        if (sectionInfo) {
            const [startHour, endHour] = sectionInfo.time_period.split('-').map(time => parseInt(time));
            setSectionData({
                ...sectionInfo,
                startHour: startHour,
                endHour: endHour,
            });
        }
    }, [sectionInfo]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);

            // Format the time_period value before sending the request
            const time_period = `${sectionData.startHour}-${sectionData.endHour}`;
            const dataToSend = { ...sectionData, time_period };

            const data = sectionInfo
                ? await updateSection(token, sectionInfo.id, dataToSend)
                : await createSection(token, dataToSend);
            console.log(sectionInfo ? 'Updated section successfully' : 'Added section successfully', data);
            onClose();
            // Trigger the callback function to notify the parent component of the update
            if (onSectionUpdate) {
                onSectionUpdate();
            }
        } catch (error) {
            console.error('Error creating/updating section:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const increaseHour = (type) => {
        setSectionData((prevData) => ({
            ...prevData,
            [type === 'start' ? 'startHour' : 'endHour']: prevData[type === 'start' ? 'startHour' : 'endHour'] === 12 ? 1 : prevData[type === 'start' ? 'startHour' : 'endHour'] + 1,
        }));
    };

    const decreaseHour = (type) => {
        setSectionData((prevData) => ({
            ...prevData,
            [type === 'start' ? 'startHour' : 'endHour']: prevData[type === 'start' ? 'startHour' : 'endHour'] === 1 ? 12 : prevData[type === 'start' ? 'startHour' : 'endHour'] - 1,
        }));
    };

    const handleNewGroupChange = () => {
        setNewGroup(prevState => !prevState);
        if (!newGroup) {
            // If switching to a new group, reset group selection
            setSectionData(prevData => ({ ...prevData, group: '' }));
        } else {
            // If switching back to an existing group, set the group to the first group by default
            setSectionData(prevData => ({ ...prevData, group: groups.length > 0 ? groups[0] : '' }));
        }
    };

    const handleDeleteSection = async () => {
        try {
            await deleteSection(token, sectionInfo.id);
            console.log('Section deleted successfully');
            onClose();
            // Trigger the callback function to notify the parent component of the update
            if (onSectionUpdate) {
                onSectionUpdate();
            }
        } catch (error) {
            console.error('Error deleting section:', error);
        }
    };

    return (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50 px-2 pb-6 pt-10">
            <div className="bg-white rounded-lg shadow-lg p-5 mt-4 mx-4" style={{ height: '100vh',overflowY:"auto"}}>
            <div className="flex justify-end mb-2">
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-800 focus:outline-none">
                        <FiX className="h-6 w-6" />
                    </button>
                </div>
                <div className="flex justify-between items-center">                    
                    <h3 className="text-lg font-semibold mb-4">Section Info</h3>
                    <button onClick={handleDeleteSection} className="text-red-500 hover:text-red-700 focus:outline-none">
                       {sectionInfo&& <FiTrash2 className="h-6 w-6" />}
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="days mb-4" className="mb-2">Days:</label>
                        <div className="flex flex-wrap justify-between mx-2 mt-2 lg:mx-0">
                            {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day) => (
                                <button
                                    key={day}
                                    type="button"
                                    onClick={() => setSectionData((prevData) => ({ ...prevData, days: day }))}
                                    className={`rounded-full bg-gray-300 px-4 py-2 mb-2 mr-2 ${sectionData.days === day ? 'bg-gray-500' : ''}`}
                                >
                                    {day}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="time mb-2" className="mb-4">Time Period:</label>
                        <div className="flex flex-col my-2 lg:flex-row items-center mb-4">
                            <div className="relative flex-1 text-center">
                                <button onClick={() => increaseHour('start')} type="button" className="absolute top-0 left-0 w-full px-2 text-gray-600 focus:outline-none">
                                    <FiChevronUp />
                                </button>
                                <input
                                    type="text"
                                    value={sectionData.startHour < 10 ? `0${sectionData.startHour}` : sectionData.startHour}
                                    readOnly
                                    className="border-none rounded-md px-3 py-2 text-center"
                                />

                                <button onClick={() => decreaseHour('start')} type="button" className="absolute bottom-0 left-0 w-full px-2 text-gray-600 focus:outline-none">
                                    <FiChevronDown />
                                </button>
                            </div>
                            <div className="mx-2">-</div>
                            <div className="relative flex-1 text-center">
                                <button onClick={() => increaseHour('end')} type="button" className="absolute top-0 left-0 w-full px-2 text-gray-600 focus:outline-none">
                                    <FiChevronUp />
                                </button>
                                <input type="text" value={sectionData.endHour < 10 ? `0${sectionData.endHour}` : sectionData.endHour} readOnly className="border-none rounded-md px-3 py-2 text-center" />
                                <button onClick={() => decreaseHour('end')} type="button" className="absolute bottom-0 left-0 w-full px-2 text-gray-600 focus:outline-none">
                                    <FiChevronDown />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="color" className="mb-2">Color:</label>
                        <div className="flex space-x-2">
      {colors.map((col) => (
        <button
          key={col}
          type="button"
          onClick={() => handleColorClick(col)}
          className={`rounded-full px-4 py-2 ${selectedColor === col ? `bg-${col}-900` : ''}`}
          style={{ backgroundColor: `${col}`, opacity: selectedColor === col ? 1 : 0.6 }}
        ></button>
      ))}
    </div>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="notes" className="mb-2">Notes:</label>
                        <textarea value={sectionData.notes} onChange={(e) => setSectionData((prevData) => ({ ...prevData, notes: e.target.value }))} className="border rounded-md px-3 py-2 w-full"></textarea>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="group" className="mb-2">Group:</label>
                        <div className="flex items-center mb-2">
                            <input
                                type="checkbox"
                                checked={newGroup}
                                onChange={handleNewGroupChange}
                                className="mr-2"
                            />
                            <span>New group</span>
                        </div>
                        {newGroup ? (
                            <input
                                type="text"
                                value={sectionData.group}
                                onChange={(e) => setSectionData((prevData) => ({ ...prevData, group: e.target.value }))}
                                placeholder="Enter new group name"
                                className="border rounded-md px-3 py-2 w-full"
                            />
                        ) : (
                            <select
                                value={sectionData.group}
                                onChange={(e) => setSectionData((prevData) => ({ ...prevData, group: e.target.value }))}
                                className="border rounded-md px-3 py-2 w-full"
                            >
                                <option value="">Select a group</option>
                                {groups.map((groupName, index) => (
                                    <option key={index} value={groupName}>{groupName}</option>
                                ))}
                            </select>
                        )}
                    </div>
                    <div className='flex justify-center'>
                        <button
                            type="submit"
                            className="border-2 border-green-500 bg-none hover:bg-green-500 text-bold px-9 py-2 rounded-full focus:outline-none"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Loading...' : sectionInfo ? 'Update' : 'Submit'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddSection;
